import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container" }

import {searchSaleOrder} from '@/api/order';
import {h, onMounted, reactive, VNode} from 'vue'
import STATUS from "@/components/model/enum"
import {saleOrderRefund, saleOrderUnrelated} from "@/api/sale_order";
import {message} from "ant-design-vue";
import {copyToClip} from "@/utils/clip";
import mobileView from "@/components/view/mobileView.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const columns = [
    {
        title: "序号",
        dataIndex: "key",
        key: "key",
        customRender: ({ index }: any) => `${index + 1}`,
    },
    {
        title: "客户",
        children: [
            {
                title: "姓名",
                dataIndex: "leadName",
                key: "leadName",
            },
            {
                title: "性别",
                dataIndex: "leadGender",
                key: "leadGender",
                customRender: ({ record }: any) => `${STATUS('genderType').getDesc(record.leadGender)}`
            },
            {
                title: "电话",
                dataIndex: "leadMobile",
                key: "leadMobile",
                width: 130,
                customRender: function({record}: any): VNode {
                    return h(mobileView,
                        {
                            mobile: record.leadMobile,
                            title: '点击复制',
                            onClick: () => copyToClip(record.leadMobile),
                        },
                        () => { return record.leadMobile })
                },
            },
            {
                title: "治疗项目",
                dataIndex: "treatName",
                key: "treatName",
            },
        ]
    },
    {
        title: "日期",
        dataIndex: "creationDate",
        key: "creationDate",
        width: 180
    },
    {
        title: "诊所",
        dataIndex: "clinicName",
        key: "clinicName",
    },
    {
        title: "医生",
        dataIndex: "dentistName",
        key: "dentistName",
    },
    {
        title: "付款",
        children: [
            {
                title: "金额",
                dataIndex: "amount",
                key: "amount",
            },
            {
                title: "付款方",
                dataIndex: "paySubject",
                key: "paySubject",
            },
            {
                title: "状态",
                dataIndex: "statusStr",
                key: "statusStr",
            }
        ]
    },
    {
        title: "操作",
        dataIndex: "operation",
        key: "operation",
    },

];
const data = reactive({
    dataSource: [],
    pagination: {
        size: "small",
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ["10", "20", "30"],
        showTotal: (total: string) => {
            return " 共" + total + "条";
        },
        hideOnSinglePage: false,
        showSizeChanger: true,
    },
    loading: true,
})
onMounted(() => {
    onSerach();
});
const changePageIndex = (page: any) => {
    data.pagination.pageSize = page.pageSize;
    data.pagination.current = page.current;
    onSerach();
}

const onSerach = () => {
    data.loading = true;
    let option = {
        page: {
            currPage: data.pagination.current,
            pageSize: data.pagination.pageSize
        }
    }
    searchSaleOrder(option).then((res: any) => {
        data.loading = false;
        data.dataSource = [];
        data.pagination.total = 0;
        if (res.data) {
            data.dataSource = res.data
            data.pagination.total = res.records;
        }
    })
}

const onRefund = (id:string)=>{
    data.loading = true;
    saleOrderRefund(id).then(()=>{
        onSerach()
        data.loading = false;
        message.success("退款成功！");
    })
}
const onUnrelated = (id:string)=>{
    data.loading = true;
    saleOrderUnrelated(id).then(()=>{
        onSerach()
        data.loading = false;
        message.success("解除关系成功！");
    })
}

// const cancelOrder  = (record: any)=>{
//     deleteInstance({bizId:record.id,bizType:19}).then((res: any)=>{
//         onSerach();
//     })
// }

return (_ctx: any,_cache: any) => {
  const _component_CheckOutlined = _resolveComponent("CheckOutlined")!
  const _component_CloseOutlined = _resolveComponent("CloseOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_table, {
      bordered: "",
      dataSource: data.dataSource,
      columns: columns,
      loading: data.loading,
      pagination: data.pagination,
      onChange: changePageIndex,
      scroll: { y:400},
      size: "small"
    }, {
      bodyCell: _withCtx(({ column, record }) => [
        (column.dataIndex === 'paid')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (record.paid)
                ? (_openBlock(), _createBlock(_component_CheckOutlined, { key: 0 }))
                : (_openBlock(), _createBlock(_component_CloseOutlined, { key: 1 }))
            ], 64))
          : _createCommentVNode("", true),
        (column.dataIndex === 'operation')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (record.status == 3)
                ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                    key: 0,
                    title: "确定退款?",
                    "ok-text": "是",
                    "cancel-text": "否",
                    onConfirm: ($event: any) => (onRefund(record.id))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, { type: "link" }, {
                        default: _withCtx(() => [
                          _createTextVNode("退款")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"]))
                : _createCommentVNode("", true),
              (record.status != 7 && record.status != 9 && record.status != 4)
                ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                    key: 1,
                    title: "确认要解除绑定关系?",
                    "ok-text": "是",
                    "cancel-text": "否",
                    onConfirm: ($event: any) => (onUnrelated(record.id))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, { type: "link" }, {
                        default: _withCtx(() => [
                          _createTextVNode("解除绑定关系")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["dataSource", "loading", "pagination"])
  ]))
}
}

})